/* Additional cards only; original Living Collection script is preserved. */
(() => {
  function revealExtras() {
    const cards = document.querySelectorAll('.linfa-living-extras .lc-card:not([data-extra-ready])');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const io = !reduced && 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach((entry, i) => { if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('is-in'), i * 90); io.unobserve(entry.target);
      } });
    }, { threshold: 0.14, rootMargin: '0px 0px -60px 0px' }) : null;
    cards.forEach(card => { card.dataset.extraReady = 'true'; if (io) io.observe(card); else card.classList.add('is-in'); });
  }
  revealExtras();
  if (!window.linfaExtrasEditorListener) {
    document.addEventListener('shopify:section:load', revealExtras);
    window.linfaExtrasEditorListener = true;
  }
})();
